import { useSnackbar } from '../../../global/config/useSnackbar';
import { useEndpointFetch } from '../../../global/network/useEndpointFetch';

export const useCreateTrialAccount = () => {
  return useEndpointFetch<{
    tenantName: string;
    region: string;
    vols: string;
    hearAt: string;
    agreedTerms: boolean;
    firstName: string;
    lastName: string;
    contactNumber: string;
    email: string;
  }>('/tm/tenant/create-trial', { withAuth: false });
};

export const useResendVerifyEmailFetch = () => {
  return useEndpointFetch('/im/user/email/tenantless-resend-verify', { withAuth: false });
};

export const useTrialAccountActions = () => {
  const createTrialUserAccount = useCreateTrialAccount();
  const { setSnackbar } = useSnackbar();

  const runCreateTrialAccount = ({
    tenantName,
    region,
    vols,
    hearAt,
    agreedTerms,
    firstName,
    lastName,
    contactNumber,
    email,
    handleSuccess,
  }: {
    tenantName: string;
    region: string;
    vols: string;
    hearAt: string;
    agreedTerms: boolean;
    firstName: string;
    lastName: string;
    contactNumber: string;
    email: string;
    handleSuccess?: () => void;
  }) => {
    createTrialUserAccount
      .run({
        tenantName,
        region,
        vols,
        hearAt,
        agreedTerms,
        firstName,
        lastName,
        contactNumber,
        email,
      })
      .then((res) => {
        if (res.status === 403) {
          setSnackbar({
            open: true,
            message: 'Too many trial requests, try again later',
            variant: 'error',
          });
          return;
        }

        if (!res.ok) {
          setSnackbar({
            open: true,
            message: 'Unable to generate trial',
            variant: 'error',
          });
          return;
        }

        setSnackbar({
          open: true,
          message: 'Your account has been created',
          variant: 'success',
        });
        if (handleSuccess) handleSuccess();
      })
      .catch(() =>
        setSnackbar({
          open: true,
          message: 'Unable to create user account',
          variant: 'error',
        })
      );
  };

  return {
    runCreateTrialAccount,
    runCreateTrialAccountLoading: createTrialUserAccount.isLoading,
    runCreateTrialAccountSuccess: createTrialUserAccount.response?.ok,
    runCreateTrialAccountError: createTrialUserAccount.error,
  };
};
